import { GPTGameObjectType } from '../../../types';
import { twJoin } from 'tailwind-merge';

import styles from './styles.module.css';
import { useDeviceDetect } from 'react-easyrocket';

export const useOrientationClassName = (orientation: GPTGameObjectType['orientation']) => {
  const { isMobile } = useDeviceDetect();

  const classNames = {
    portrait: twJoin(
      isMobile && 'portrait:w-full portrait:h-full',
      isMobile && 'landscape:h-full landscape:aspect-[640/1024]',
      !isMobile && 'aspect-[640/1024] max-h-[1024px] h-[95%] rounded-2xl'
    ),

    landscape: twJoin(
      isMobile && 'landscape:w-screen landscape:h-full',
      isMobile && 'portrait:w-screen portrait:aspect-[22.6/9]',
      !isMobile && 'aspect-[22.6/9] max-w-[1280px] w-full rounded-2xl'
    ),
    'universal-landscape': twJoin(
      isMobile && `${styles['screen-height']} ${styles['screen-width']}`,
      !isMobile && 'aspect-[22.6/9] max-w-[1280px] w-full rounded-2xl'
    )
  };

  return classNames[orientation];
};
